import React, {
    Component
  }                         from 'react';
  import PropTypes          from 'prop-types';
  import {
    AnimatedView,
    StatsCard,
    WorkProgress
  }                         from '../../components';
  import { connect }    from 'react-redux';
  import {
    Row,
    Col,
    Button,
    FormGroup,
    FormControl,
    ControlLabel,
    Alert,
    Panel,
    PanelGroup
    
  }                     from 'react-bootstrap';
  import { withRouter } from 'react-router';
  import {
    bindActionCreators,
    compose
  }                     from 'redux';
  import { createHashHistory } from 'history';
  import loader from '../../style/loader/loader.scss';
  import { Link } from "react-router-dom";
  import isEmpty from 'lodash.isempty';
  import { CSVLink } from "react-csv";

  
  const history = createHashHistory();

  let isLoading='false', csvData = [];
  class MonthlyReport extends Component {

    constructor(props){
      super(props);
      this.state={
        show: false,
        alertMessage:'',
        disabled: false,
        monthyeardata:[],
        groupedData:[],
        monthdata:'',
        msgType:'',
        siteID:'',
        month:'',
        csvData: "",
        showValue: "",
        reportData: "",
      }
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleDismiss = this.handleDismiss.bind(this);
      this.handleShow = this.handleShow.bind(this);
    }

    handleDismiss() {
      this.setState({ show: false });
      //console.log('show', false)
    }
  
    handleShow() {
      this.setState({ show: true });
    }

    handleMonthChange(e){
      //console.log(e.target.name,e.target.value)
    
      if(`${e.target.name}Error` !== ''){
       
        this.setState({[`${e.target.name}Error`]:''})
      }
     
      this.setState({[e.target.name]:e.target.value})
      
    }

    handleSiteChange(e){
      //console.log(e.target.name,e.target.value)
    
      if(`${e.target.name}Error` !== ''){
       
        this.setState({[`${e.target.name}Error`]:''})
      }
     
      this.setState({[e.target.name]:e.target.value})
      
    }
    

    componentWillMount(){
      const {
        actions: { getMonth }
      } = this.props;
      getMonth();
      const {
        actions: { getSiteList }
      } = this.props;
      getSiteList({page:0});
      isLoading='true';
    }

    componentWillReceiveProps(nextProps){
      if(this.props.error !== nextProps.error){
        if(nextProps.error){
          //this.props.clearAlert ();
          this.handleShow();
          //this.props.renderAlert('warning',nextProps.error);
          isLoading="false";
          
        }
      } 
     

      if(this.props.MonthData !== nextProps.MonthData){
        if(!isEmpty(nextProps.MonthData)){
          this.setState({monthdata: nextProps.MonthData})
          
          let month= nextProps.MonthData;
          const postData={
            selectMonth: month[0]
          }
          const {
            actions: { getPastMonthSales }
          } = this.props;
          getPastMonthSales(postData);
        }
      }

      if (this.props.reportData !== nextProps.reportData) {
        if (nextProps.reportData) {
          isLoading = "false";
          this.setState({ reportData: nextProps.reportData.data });
          this.handleExport(nextProps.reportData.data);
        }
      }           

      if(this.props.siteList !== nextProps.siteList){
        if(nextProps.siteList){
          this.setState({sitedata: nextProps.siteList})
        }
      }       

      if(nextProps.message){
        this.handleShow();
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
      }
     
  }


  handleSubmit(e){
    e.preventDefault();
    let postData;
      
      isLoading = 'true';
     
        postData = {
          selectMonth: this.state.month,
          siteID: this.state.siteID
        }
      const {
        actions: { getPastMonthSales }
      } = this.props;
      getPastMonthSales(postData);
  }

  handleExport = data => {
   // let setDate = (this.state.range == true) ? moment(this.state.startDate).format('MM/DD/YYYY') +' - '+moment(this.state.endDate).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');

   let csvData = [
    [
        'Market',
        'Gross Billing',
        'Revenue',
        'Offers Ran',
        'Unique Merchants',
        'Rev Unique Merchant',
        'Vouchers Sold',
        'Vouchers/Offer',
        'Avg Price',
        'Avg Discount',
        'Avg Take Rate',
        'New Buyers',
        'Total Buyers',
    ],
];

if (data) {
    data.forEach((dataValue) => {
        // Add the title row
        if (dataValue.title) {
            csvData.push([dataValue.title]);
        }

        // Add deal_data details
        if (dataValue.deal_data) {
            csvData.push([
                '',
                dataValue.deal_data.gross_billing || '',
                dataValue.deal_data.revenue || '',
                dataValue.deal_data.offers_ran || '',
                dataValue.deal_data.unique_merchants || '',
                dataValue.deal_data.rev_unique_merchant || '',
                dataValue.deal_data.vouchers_sold || '',
                dataValue.deal_data.deals_quantity || '',
                dataValue.deal_data.average_price || '',
                dataValue.deal_data.average_discount || '',
                dataValue.deal_data.average_take_rate || '',
                dataValue.deal_data.new_buyers || '',
                dataValue.deal_data.total_buyers || '',
            ]);
        }
    });
}



    this.setState({ csvData: csvData });
  };

  showData = (value) => {
    this.setState({showValue: value});
  }

  hideData = () => {
    this.setState({showValue: ''});
  }



    render() {
    // console.log('month',this.state.month, this.state.siteID)
     if(this.props.error){
      isLoading="false";
    }

      let siteNamefromID = "";

      if(!isEmpty(this.state.sitedata)) {
             this.state.sitedata.map((site, index) => {
                  if(site.siteID === this.state.siteID) {
                      siteNamefromID = site.siteName;
                   }                            
                 }                            
             )
        }
       
        return (
          <div className="col-lg-12 add-sub-admin">
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
       
       <div className="row">
          <div className="col-xs-12">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
        <div className="panel">
          <header className="panel-heading">Past Month Performance Report</header>
          <div className="panel-body">
            <Row>
              <Col md={3} xs={12}>
                <FormGroup controlId="site">
                  <ControlLabel>Site</ControlLabel>
                  <FormControl componentClass="select" style={{borderColor:this.state.siteError}} name="siteID" onChange={this.handleSiteChange.bind(this)} value={this.state.siteID}>
                    <option value="">Select Site</option>
                    {(!isEmpty(this.state.sitedata)) && 
                      this.state.sitedata.map((site, index) => 
                        <option key={index} value={site.siteID}>{site.siteName}</option>
                      )
                    }
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} xs={12}>
                <FormGroup controlId="monthyear">
                  <ControlLabel>Month</ControlLabel>
                  <FormControl componentClass="select" style={{borderColor:this.state.monthyearError}} name="month" onChange={this.handleMonthChange.bind(this)} value={this.state.month}>
                    <option value="">Select Month</option>
                    {(!isEmpty(this.state.monthdata)) && 
                      this.state.monthdata.map((month, index) => 
                        <option key={index} value={month}>{month}</option>
                      )
                    }
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
            <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                
                </Col>
              </Row>
          </div>
        </div> 
        </form>
       

        <div className="panel">      
          <div className="panel-body table-responsive">
            <span className="pull-right">
                {this.state.csvData ? (
                  <CSVLink
                    data={this.state.csvData}
                    filename={"past-month-performance-report.csv"}
                    className="btn btn-danger"
                  >
                    Export CSV
                  </CSVLink>
                ) : null}
              </span>
            <table className="table table-hover">
              <thead>
                    <tr>
                        <th colSpan='3'>
                            Data for the month: 
                        </th>
                        <th colSpan='4'>
                        {siteNamefromID} - {this.state.month}
                        </th>
                    </tr>
                    <tr>
                        <th>Market</th>
                        <th>Gross Billings</th> 
                        <th>Revenue</th> 
                        <th>Offer Ran</th> 
                        <th>Unique Merchants</th>
                        <th>Rev Unique Merchant</th>
                        <th>Vouchers Sold</th>
                        <th>Vouchers/Offer </th>
                        <th>Avg Price </th>
                        <th>Avg Discount </th> 
                        <th>Avg Take Rate </th> 
                        <th>New Buyers </th>
                        <th>Total Buyers </th> 
                    </tr>
                </thead>
                <tbody>
        {this.state.reportData && this.state.reportData.length > 0 ? (
            this.state.reportData.map((data, index) => (
                <React.Fragment key={index}>
                    {/* Title row */}
                    <tr>
                        <td colSpan="12">
                            {(this.state.showValue === index) ? (
                                <a
                                    className="cursor text-danger"
                                    onClick={this.hideData}
                                >
                                    <i className="fa fa-minus-circle"></i>
                                </a>
                            ) : (
                                <a
                                    className="cursor text-success"
                                    onClick={() => this.showData(index)}
                                >
                                    <i className="fa fa-plus-circle"></i>
                                </a>
                            )}
                            &nbsp; {data.title}
                        </td>
                    </tr>
                    
                    {/* Details row */}
                    {this.state.showValue === index && (
                        <tr>
                                   <td></td>
                            <td>{data.deal_data.gross_billing}</td>
                            <td>{data.deal_data.revenue}</td>
                            <td>{data.deal_data.offers_ran}</td>
                            <td>{data.deal_data.unique_merchants}</td>
                            <td>{data.deal_data.rev_unique_merchant}</td>
                            <td>{data.deal_data.vouchers_sold}</td>
                            <td>{data.deal_data.deals_quantity}</td>
                            <td>{data.deal_data.average_price}</td>
                            <td>{data.deal_data.average_discount}</td>
                            <td>{data.deal_data.average_take_rate}</td>
                            <td>{data.deal_data.new_buyers}</td>
                            <td>{data.deal_data.total_buyers}</td>
                        </tr>
                    )}
                </React.Fragment>
            ))
        ) : (
            <tr>
                <td colSpan="12">Data Not Found</td>
            </tr>
        )}
    </tbody>
</table>

          </div>
        </div>
       
      </div>
      
      );
    }
  }

  export default MonthlyReport;



// WEBPACK FOOTER //
// ./src/app/views/monthlyReport/MonthlyReport.js